import React from 'react'

import { Button } from '@sketch/components'
import { getIsForInAppPresentation, useFlag } from '@sketch/modules-common'
import { Container, Divider } from './SocialSignIn.styles'
import { useGetSocialSignIn } from '../../hooks'

export const SocialSignIn = () => {
  // SWEB-1921: Remove the social-auth FF
  // https://linear.app/sketch/issue/SWEB-1921/remove-the-social-auth-ff
  const isSocialAuthEnabled = useFlag('social-auth')

  const { getSocialSigninStartUrl, loading } = useGetSocialSignIn()

  const isForInAppPresentation = getIsForInAppPresentation()

  // Don't render if its for in-app presentation
  if (!isSocialAuthEnabled || isForInAppPresentation) {
    return null
  }

  const handleAppleSignIn = () => {
    getSocialSigninStartUrl({
      variables: {
        provider: 'APPLE',
      },
    })
  }

  return (
    <Container>
      <Button
        variant="primary-untinted"
        size="40"
        fill
        onClick={handleAppleSignIn}
        loading={loading}
      >
         Continue with Apple
      </Button>
      <Divider>or</Divider>
    </Container>
  )
}
